import script from "./NearMissPlayVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./NearMissPlayVideo.vue?vue&type=script&lang=ts&setup=true"

import "./NearMissPlayVideo.vue?vue&type=style&index=0&id=edde18cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edde18cc"]])

export default __exports__